import { Component, EventEmitter, OnInit, Output, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { GroupementCriteresService } from 'src/app/services/groupement-criteres/groupement-criteres.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { GroupementCriteres } from 'src/app/utils/interfaces/new/GroupementCriteres';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';

@Component({
  selector: 'groupement-new',
  templateUrl: './groupement-new.fragment.html',
  styleUrls: ['./groupement-new.fragment.scss', '../modal.fragment.scss'],
})

export class GroupementNewFragment implements OnInit {
  public formGroup: FormGroup;
  public nomTable: string;
  public header = '';
  public errorMessage = '';
  public refreshStream: Subject<any>;
  public groupement: GroupementCriteres;

  @Output() public closeEmitter = new EventEmitter();

  constructor(
    private _formBuilder: FormBuilder,
    public viewContainerRef: ViewContainerRef,
    public modalService: ModalService,
    private groupementSvc: GroupementCriteresService
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      libelle: ['', Validators.required]
    });
    if (this.groupement) {
      this.formGroup.controls['libelle'].setValue(this.groupement.titre);
    }
  }

  public async onSubmit(): Promise<void> {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      try {
        if (this.groupement) {
          this.groupement.titre = this.formGroup.controls['libelle'].value
          await this.groupementSvc.updateGroupementCriteres(this.groupement);
        } else {
          let groupement = { id: '', titre: this.formGroup.controls['libelle'].value };
          await this.groupementSvc.addGroupementCriteres(groupement);
        }
        this.refreshStream.next();
        this.closeRechercheModal();
      } catch (error) {
        console.error(error);
        this.errorMessage = error;
      }
    }
  }

  public closeRechercheModal(): void {
    this.closeEmitter.emit(null);
  }

  public stopPropagation(event: any): void {
    event.stopPropagation();
  }
}
